/* 2026-09-01/09-14 筛选器标签中改英（Search & Discovery 源数据为中文；
   v2 改为子串替换，覆盖"供货情况: In stock"这类筛选后标签；源数据改英后自动无操作） */
(function () {
  var MAP = { '价格': 'Price', '供货情况': 'Availability' };
  function swap(s) {
    var r = s;
    for (var k in MAP) { if (r.indexOf(k) > -1) r = r.split(k).join(MAP[k]); }
    return r;
  }
  function walk(node) {
    if (node.nodeType === 3) {
      var nv = swap(node.nodeValue);
      if (nv !== node.nodeValue) node.nodeValue = nv;
    } else if (node.nodeType === 1) {
      var attrs = ['aria-label', 'placeholder', 'title'];
      for (var i = 0; i < attrs.length; i++) {
        var v = node.getAttribute && node.getAttribute(attrs[i]);
        if (v) { var nv2 = swap(v); if (nv2 !== v) node.setAttribute(attrs[i], nv2); }
      }
      node.childNodes.forEach(walk);
    }
  }
  function run(root) { walk(root || document.body); }
  document.addEventListener('DOMContentLoaded', function () {
    run();
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) run(n); });
        if (m.type === 'characterData') { var nv = swap(m.target.nodeValue); if (nv !== m.target.nodeValue) m.target.nodeValue = nv; }
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  });
})();
